module.exports = __webpack_public_path__ + "static/media/226-united-states.44cef35d.svg";